import React, { useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import Box from '@tds/core-box';
import Input from '@tds/core-input';
import Button from '@tds/core-button';
import DimpleDivider from '@tds/core-dimple-divider';
import { Delete } from '@tds/core-interactive-icon';
import { Accordion } from '@tds/core-expand-collapse';
import { useTranslationsContext } from '../../../context/TranslationsContext';

import { Heading } from '../css';

const CustomFeatures = ({ selectedFeatures, setSelectedFeatures }) => {
  const {
    WLS: {
      WIRELESS_ORDER_DETAILS: {
        AdditionalFeatures: {
          Name,
          Price,
          AdditionalFeatures,
          AddFeature,
          AdditionalFeaturesList
        }
      }
    }
  } = useTranslationsContext();

  const [customFeatureName, setCustomFeatureName] = useState();
  const [customFeaturePrice, setCustomFeaturePrice] = useState();
  const customFeatures = selectedFeatures.filter(feature =>
    _.get(feature, 'isCustom', false)
  );

  const addCustomFeature = () => {
    if (customFeatureName && customFeaturePrice) {
      setSelectedFeatures([
        ...selectedFeatures,
        {
          id: uuidv4(),
          name: customFeatureName,
          price: +customFeaturePrice,
          isCustom: true
        }
      ]);
      setCustomFeatureName('');
      setCustomFeaturePrice('');
    }
  };

  const removeCustomFeature = id => {
    const updatedList = selectedFeatures.filter(feature => feature.id !== id);
    setSelectedFeatures(updatedList);
  };
  return (
    <Accordion tag="h3">
      <Accordion.Panel id="features" header={AdditionalFeatures}>
        <Box between={2}>
          <Input
            id="accessoryName"
            label={Name}
            value={customFeatureName}
            onChange={e => {
              setCustomFeatureName(e.target.value);
            }}
          />
          <Input
            id="accessoryPrice"
            label={Price}
            value={customFeaturePrice}
            type="number"
            onChange={e => {
              setCustomFeaturePrice(e.target.value);
            }}
          />
          <Button id="features" onClick={addCustomFeature}>{AddFeature}</Button>
          {customFeatures.length > 0 && (
            <>
              <DimpleDivider />
              <div className="card">
                <div className="card-header">
                  <Heading level="h4">{AdditionalFeaturesList}</Heading>
                </div>
                <ul className="list-group list-group-flush">
                  {customFeatures.map(customFeature => (
                    <li
                      className="list-group-item"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <div style={{ backgroundColor: 'white' }}>
                        {customFeature.name} - ${customFeature.price}
                      </div>
                      <Delete
                        onClick={() => removeCustomFeature(customFeature.id)}
                        a11yText="Delete"
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )}
        </Box>
      </Accordion.Panel>
    </Accordion>
  );
};

CustomFeatures.propTypes = {
  selectedFeatures: PropTypes.arrayOf(PropTypes.any).isRequired,
  setSelectedFeatures: PropTypes.func.isRequired
};

export default CustomFeatures;
